import React, { useState, useEffect } from 'react';

import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Image, Table } from 'react-bootstrap';

import * as Common from '../Common';

function Countrydiffer() {
    const { id } = useParams();
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [reqData, setReqData] = useState([]);

    const [bankFileDate, setBankFileDate] = useState('Not Available');
    const [isd, setIsd] = useState('Not Available');
    const [qty, setQty] = useState('Not Available');
    const [beneName, setBeneName] = useState('Not Available');
    const [beneAdd, setBeneAdd] = useState('Not Available');
    const [beneBank, setBeneBank] = useState('Not Available');
    const [beneBankAdd, setBeneBankAdd] = useState('Not Available');
    const [beneBankSwift, setBeneBankSwift] = useState('Not Available');
    const [coBankName, setCoBankName] = useState('Not Available');
    const [coBankAdd, setCoBankAdd] = useState('Not Available');
    const [coverBank, setCoverBank] = useState('Not Available');
    const [coverBankName, setCoverBankName] = useState('Not Available');
    const [refNo, setRefNo] = useState('Not Available');

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'CONTRYDIFFER'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    Common.callApi(Common.apiInProgress, [sid, 'detail', id], function (result1) {
                        let resp1 = JSON.parse(result1);
                        setBankFileDate((resp1.req_bankfiletrandate).split('-').reverse().join('/'));
                        setIsd(resp1.req_isd);
                        setQty(resp1.req_quantity);
                        setBeneName(resp1.req_benename);
                        setBeneAdd(resp1.req_beneadd);
                        setBeneBank(resp1.req_benebank);
                        setBeneBankAdd(resp1.req_benebankadd);
                        setBeneBankSwift(resp1.req_beneswiftcode);
                        setCoBankName(resp1.req_corresbankname);
                        setCoBankAdd(resp1.req_corresbankadd);
                        setCoverBank(resp1.req_coverbank);
                        setRefNo(resp1.req_refno);
                        if (resp1.req_coverbank === "5") {
                            setCoverBankName('YES Bank Limited');
                        }
                        if (resp1.req_coverbank === "7") {
                            setCoverBankName('Indusind Bank Limited');
                        }
                        if (resp1.req_coverbank === "9") {
                            setCoverBankName('ICICI Bank Limited');
                        }
                        setReqData(resp1);
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    return (
        <>
            <Container>
                <Row>
                    <Col>
                        <b>{refNo}</b><br></br>
                        Date : {bankFileDate}<br></br><br></br>
                        To,<br></br>
                        {coverBankName}
                        <br></br>
                        …………………….. branch,<br></br><br></br>
                        Sub : Outward Remittance – Payment to Beneficiary account held in country other than where he is located and conducts regular business<br></br><br></br>
                        Dear Sir/Madam,<br></br>
                        We refer to our request letter dated <b>{bankFileDate}</b>  For outward remittance amount <b>{qty} {isd}</b> in favour of <b>{beneName} & {beneAdd}</b> (name of beneficiary and address).<br></br><br></br>
                        We hereby confirm payment being made to the bank account mentioned in our letter is correct.<br></br><br></br>
                        Our beneficiary has confirmed that their correct bank details to be<br></br><br></br>
                        Name of Beneficiary bank & city : <b>{beneBank} & {beneBankAdd}</b><br></br><br></br>
                        Swift Code : <b>{beneBankSwift}</b><br></br><br></br>
                        Intermediary Bank details : {coBankName === "" ? null : <><b>{coBankName} & {coBankAdd}</b> </>}    <br></br><br></br>
                        We take full responsibility for this payment, we have taken into account the possibility of email hacking and have reconfirmed with the beneficiary through other modes of communication, other than email and have satisfied ourselves of the genuiness of the beneficiary bank details for processing the payment.<br></br><br></br>
                        We hold the bank harmless of any action, in case of implications arising from this payment going to wrong account and funds not reaching the beneficiary.<br></br><br></br>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default Countrydiffer;